export const API = {
  // PRODUCT
  product: {
    // V2
    FETCH__ALL: () => '/api/v2/products',
    FETCH__BY_ID: id => `/api/v2/products/${id}`,
    FETCH__CALC: () => '/api/v2/products/calc',
  },
  // COMMERCIAL_PRODUCT
  commercial_product: {
    // V2
    FETCH__ALL: () => '/api/v2/products/commercial_product'
  },
};
